import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import moment, { Moment } from "moment";
import { RefundsService } from "../../../../auth/service/refunds.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IRefund, IUpdateRefundKilometer } from "app/auth/models/refunds";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-refunds-requested-list",
  templateUrl: "./refunds-requested-list.component.html",
  styleUrls: ["./refunds-requested-list.component.scss"],
})
export class RefundsRequestedListComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @ViewChild("viewRefund") mymodal: ElementRef;
  @ViewChild("rejectRefundModal") rejectRefundModal: ElementRef;
  public contentHeader: IContentHeader;
  public refunds: IRefund[];
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public searchStatus: number = 0;
  public currentRefund: any;
  public me: ICurrentUser;
  public idFromNotifications: number = 0;
  public rejectedNote: string = "";
  public filteredRefunds: any = [];

  selectedMonth = 0;
  months = moment.months();
  selectedYear = moment().year();
  years = Array.from({ length: moment().year() - 2022 }, (_, i) => i + 2023);

  constructor(
    public _refundService: RefundsService,
    public _utilService: UtilsService,
    private _routerService: Router,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public activatedRoute: ActivatedRoute,
  ) {
    if (!this._authenticationService.hasCapability("show_menu_requested_refunds")) {
      this._routerService.navigateByUrl("/dashboard/main");
    } else {
      this.contentHeader = {
        headerTitle: italian.data.MENU.REFUNDS_REQUESTED_LIST,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/",
            },
            {
              name: italian.data.MENU.MANAGE,
              isLink: true,
              link: "/dashboard/platform-management",
            },
            {
              name: italian.data.MENU.REFUNDS_REQUESTED_LIST,
              isLink: false,
            },
          ],
        },
      };
    }
  }

  async ngOnInit() {
    this.me = this._authenticationService.getCurrentUser();
    await this.loadRefunds();
    this.activatedRoute.queryParams.subscribe(async (params) => {
      this.idFromNotifications = Number(params.id);
      if (this.idFromNotifications) {
        this.currentRefund = this.refunds.find((ref: IRefund) => ref.id === this.idFromNotifications);
        this.openModal(this.mymodal, this.currentRefund);
      }
    });
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadRefunds() {
    const translationLabel: string[] = [];
    translationLabel[0] = await this._utilService.translate("PENDING");
    translationLabel[1] = await this._utilService.translate("APPROVED_FEMALE_SINGULAR");
    translationLabel[2] = await this._utilService.translate("NOT_APPROVED_SINGULAR");
    translationLabel[3] = await this._utilService.translate("DELETED");
    this.refunds = await this._refundService.getList().then((refunds: IRefund[]) => {
      refunds = refunds.map((item: IRefund) => ({ ...item, date: moment(item.date) }));

      refunds = refunds.sort((a, b) => {
        let dateA = a.date;
        let dateB = b.date;
        return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
      });

      return refunds.map((item: IRefund) => (item.user_hash === this.me.hash ? null : { ...item, enabled_label: translationLabel[item.status] }));
    });
    // this.refunds = this.refunds.filter((item) => item !== null);
    const countPending: number = this.refunds.filter((item) => item?.status === 0).length;
    if (countPending < 1) {
      this.searchStatus = 10;
    }

    this.filterRefunds();
  }

  filterRefunds() {
    let items: IRefund[] = (this.refunds || []).map((item: IRefund) => item);
    this.selectedMonth = Number(this.selectedMonth);

    if (items) {
      items.sort((a, b) => (a?.date < b?.date ? 1 : a?.date > b?.date ? -1 : 0));
    }

    if (!items || items.length === 0) return [];

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: IRefund) => item?.employee?.complete_name.toLowerCase().includes(keywords) || item?.amount.replace(".", "").includes(keywords));
    }

    if (this.searchStatus < 3) {
      items = items.filter((item: IRefund) => Number(item?.status) === Number(this.searchStatus));
    }

    items = items.filter((item: IRefund) => {
      if (typeof item.date === "string") {
        return moment(item.date).format("YYYY") === this.selectedYear.toString();
      }
      return item.date.format("YYYY") === this.selectedYear.toString();
    });

    if (this.selectedMonth > 0) {
      items = items.filter((item) => item && (item.date as Moment).month() === this.selectedMonth);
    }

    items = items.map((item: any) => ({ ...item, amount: this._utilService.removeDotsFromNumber(item.amount || 0) }));

    this.filteredRefunds = items.filter((i: any) => i);
  }

  openModal(modal, refund) {
    if (!refund || refund < 1) return false;
    this._modalService.open(modal, {
      centered: true,
      size: "sm",
      backdrop: false,
      keyboard: false,
    });
    this.currentRefund = refund;
  }

  modalClose() {
    this._modalService.dismissAll();
    this.callbackFn.emit();
    this.rejectedNote = "";
  }

  async rejectRefund(currentRefund) {
    if (!this._authenticationService.hasCapability("manage_refund_request")) {
      window.history.back();
      return false;
    }

    const data: IUpdateRefundKilometer = { refunds: [currentRefund.id], status_note: this.rejectedNote };
    await this._refundService
      .updateRequestedRefund("reject", data)
      .then(() => {
        this._utilService.showSWALSuccess({ text: "SUCCESS_REJECT_REFUND" });
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_EDIT_REFUND" }));
    await this.loadRefunds();
    this.modalClose();
  }

  async toggleEnabled(currentRefund, action) {
    if (!this._authenticationService.hasCapability("manage_refund_request")) {
      window.history.back();
      return false;
    }
    const data: IUpdateRefundKilometer = { refunds: [currentRefund.id], status_note: null };

    if (action === "reject") {
      this._modalService.open(this.rejectRefundModal, {
        centered: true,
        size: "sm",
      });
      return false;
    }

    await this._refundService
      .updateRequestedRefund(action, data)
      .then(() => {
        this._utilService.showSWALSuccess({ text: "SUCCESS_APPROVED_REFUND" });
        this.loadRefunds();
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_EDIT_REFUND" }));
  }

  openFile(file: string) {
    return this._utilService.getFile(file);
  }
}
